import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectAllFilters } from "../app/globalFiltersSlice"; // Importa il selettore

const useSyncFilterWithGlobalFilters = (setFilter) => {
  const globalFilters = useSelector(selectAllFilters);
  // console.log("Global Filters:", globalFilters);

  useEffect(() => {
    // Crea un oggetto con tutti i filtri globali
    const globalFilterValues = globalFilters.reduce((acc, filter) => {
      acc[filter.key] = filter.value || "";
      return acc;
    }, {});

    setFilter((prev) => ({
      ...prev,
      ...globalFilterValues,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilters]);
};

export default useSyncFilterWithGlobalFilters;
